(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("settingsTimeZone", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/general/timeZone/settingsTimeZoneView.html",
            controller: ["timeZoneResource", "tenantResource", "timeZoneService", "messageService", "_", SettingsTimeZoneCtrl],
            controllerAs: "vm"
        };
        function SettingsTimeZoneCtrl(timeZoneResource, tenantResource, timeZoneService, messageService, _) {
            var vm = this;
            vm.saving = false;
            var model = { timeZone: "" };
            vm.isTimeZoneSet = false;
            timeZoneResource.getListOfTimeZones(function (data) {
                vm.timeZones = data;
                tenantResource.getTimeZone(function (tenantTimeZoneData) {
                    //Set Time Zone To Tenants
                    if (tenantTimeZoneData.timeZone) {
                        vm.isTimeZoneSet = true;
                        vm.selectedTimeZone = _.find(vm.timeZones, { Id: tenantTimeZoneData.timeZone.Id });
                    }
                    else {
                        vm.isTimeZoneSet = false;
                        vm.selectedTimeZone = timeZoneService.detectTimeZone(vm.timeZones);
                    }
                });
            });
            vm.save = function () {
                if (vm.saving)
                    return;
                vm.saving = true;
                model.timeZone = vm.selectedTimeZone.Id;
                tenantResource.saveTimeZone(model, function () {
                    messageService.success("settings.general.timeZone.save.success");
                    vm.saving = false;
                    vm.isTimeZoneSet = true;
                }, function (errorData) {
                    messageService.error(errorData);
                    vm.saving = false;
                });
            };
        }
    });
})();
